import React from 'react';
import { AlertCircle } from 'lucide-react';

export function CurrencyNotice({ currencyCode, notes = [] }) {
  const hasMixed = currencyCode === 'MIXED';
  if (!hasMixed && !currencyCode) return null;

  return (
    <div className="rounded-xl border border-slate-200/90 bg-white px-4 py-3 text-sm text-slate-600 shadow-[0_4px_16px_rgba(15,23,42,0.08)]">
      <div className="font-semibold text-slate-700">Currency</div>
      <div className="mt-1">
        {hasMixed
          ? 'Mixed currencies detected. Monetary totals are not combined; filter to a single currency for accurate totals.'
          : `Currency: ${currencyCode}`}
      </div>
      {hasMixed && notes.length > 0 && (
        <div className="mt-2 text-xs text-slate-500">
          {notes.find((note) => note.toLowerCase().includes('multiple currencies')) || notes[0]}
        </div>
      )}
    </div>
  );
}

export function RefreshIndicator() {
  return (
    <div className="fixed bottom-20 left-4 z-30 flex items-center gap-2 rounded-sm border border-slate-200 bg-white px-3 py-2 text-[11px] text-slate-500 shadow-md sm:bottom-4 sm:left-auto sm:right-4">
      <span className="h-1.5 w-1.5 rounded-full bg-[#201C35] animate-pulse" />
      Refreshing data...
    </div>
  );
}

export function ErrorBanner({ message }) {
  return (
    <div className="col-span-full flex items-center gap-3 rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 shadow-sm">
      <AlertCircle className="h-4 w-4 text-rose-500 flex-shrink-0" />
      <div>
        <span className="text-sm font-semibold text-rose-700">Could not load revenue data</span>
        <span className="text-sm text-rose-500 ml-1.5">{message}</span>
      </div>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="ml-auto text-[12px] font-semibold text-rose-600 hover:text-rose-800 underline"
      >
        Retry
      </button>
    </div>
  );
}
